import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import NoScript from '../NoScript';
import { useLazyLoading } from './useLazyLoading';
const LazyLoadingImage = (_param)=>{
    var { children, innerRef } = _param, props = _object_without_properties(_param, [
        "children",
        "innerRef"
    ]);
    const { enableLazyLoading, supportsNativeLazy, ref, inView } = useLazyLoading();
    const isMounted = useIsMounted();
    if (!enableLazyLoading || supportsNativeLazy) {
        return /*#__PURE__*/ React.createElement("img", _object_spread({
            alt: "",
            loading: "lazy",
            ref: innerRef
        }, props));
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, !isMounted && /*#__PURE__*/ React.createElement(NoScript, null, /*#__PURE__*/ React.createElement("img", _object_spread({
        alt: ""
    }, props))), /*#__PURE__*/ React.createElement("div", {
        ref: ref
    }, inView ? /*#__PURE__*/ React.createElement("img", _object_spread({
        ref: (node)=>{
            innerRef && innerRef(node);
        },
        alt: "",
        loading: "lazy"
    }, props)) : /*#__PURE__*/ React.createElement("svg", {
        width: props.width,
        height: props.height,
        style: props.style,
        "data-hook": props['data-hook']
    })));
};
LazyLoadingImage.displayName = 'LazyLoadingImage';
export default /*#__PURE__*/ React.memo(LazyLoadingImage);

//# sourceMappingURL=LazyLoadingImage.js.map